module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_3009.4cad28e1.png";